export interface IAdminAclGroup {
    key: string;
    label: string;
    items: string[];
}

export const ADMIN_ACL_GROUPS: IAdminAclGroup[] = [
    {
        key: 'users',
        label: 'Users & roles',
        items: ['admin', 'users', 'supervisors', 'external_users', 'change_user_roles', 'access_rights'],
    },
    {
        key: 'influencers',
        label: 'Influencers',
        items: [
            'influencers',
            'influencer_fee',
            'influencer_fee_overview',
            'user_platform_logs',
            'discovery',
            'discovery_preset',
        ],
    },
    {
        key: 'campaigns',
        label: 'Campaigns & agencies',
        items: [
            'campaigns',
            'offers',
            'agency',
            'contracts',
            'onboarding',
            'offer_pdfs',
            'contract_pdfs',
            'regenerate_pdf',
            'offer_overview',
            'contract_overview',
            'offer_event_transfer',
        ],
    },
    {
        key: 'finance',
        label: 'Finance & invoices',
        items: [
            'invoices',
            'invoice_action',
            'invoice_verification',
            'controlling',
            'controlling_kpis',
            'controlling_incoming_invoices',
            'controlling_outgoing_invoices',
            'controlling_long_term_incoming_invoices',
            'controlling_incoming_deferral',
            'controlling_agency_revenue_companies',
            'controlling_agency_revenue_campaigns',
            'budget_overview',
        ],
    },
    {
        key: 'reporting',
        label: 'Reporting & content',
        items: ['reporting', 'statistics', 'report_items', 'export', 'logs'],
    },
    {
        key: 'system',
        label: 'System',
        items: ['packages', 'platform', 'company', 'emailing', 'add_additional_item', 'modash_check'],
    },
    {
        key: 'advanced',
        label: 'Advanced',
        items: ['user_advanced_edit', 'campaign_advanced_edit'],
    },
];
